export default __webpack_public_path__ + "static/media/k3multiple.de4f7462.mp4";